import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import {
  TextBoxMaxLine1Caption4Secondary,
  TextBoxMaxLine1Footnote5,
} from 'atoms/TextBox/Templates'
import { TextBlock } from 'blocks/TextBlock'

export interface ITextBlockProgramCard extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
  locked?: boolean
}

export const TextBlockProgramCard = ({
  title,
  description,
  locked,
  ...rest
}: ITextBlockProgramCard): JSX.Element => {
  const titleMaxLines = locked ? 2 : 1
  return (
    <TextBlock {...rest}>
      <TextBoxMaxLine1Footnote5 title={title} maxLines={titleMaxLines} />
      <TextBoxMaxLine1Caption4Secondary title={description} />
    </TextBlock>
  )
}
